<template>

  <div class="box">
    <div class="row no-gutters dates">
      <div class="col-12 col-sm-6">
        <img src="/static/assets/images/ico-calendar_ok.svg">
        <label>Início</label>
        <span class="date">{{inicioCaptacao}}</span>
      </div>
      <div class="col-12 col-sm-6">
        <img src="/static/assets/images/ico-calendar_end.svg">
        <label>Término</label>
        <span class="date">{{fimCaptacao}}</span>
      </div>          
    </div>

    <hr class="divider">

    <div class="row">
      <div class="col-12 text-center">
        <label>Valor solicitado</label>
        <span class="value">R$ {{valorSolicitacao}}</span>
      </div>
    </div>

    <hr class="divider">

    <div v-if="verificaProduto(loanRequest.CodProduto)" class="row no-gutters text-center">
     <div class="col-12 col-md-12 col-lg-4">
        <label>Retorno Bruto Anual</label>
        <span class="info bold">{{formatCurrency(retornoBrutoAnual)}}% a.a.</span>
      </div>
      <div class="col-12 col-md-12 col-lg-4">
        <label>Retorno Bruto Mensal</label>
        <span class="info bold">{{formatCurrency(retornoBrutoMensal)}}% a.m.</span>
      </div>
      <div class="col-12 col-md-12 col-lg-4">
        <label>Retorno Estimado Anual</label>
        <span class="info bold">{{formatInt(cdi||0)}}% CDI</span>
      </div>
      <div class="col-12">
        <p class="small">
          * A taxa de juros acima é igual ao seu Retorno Bruto<br>(Retorno antes do desconto de IR).
        </p>
      </div>
    </div>
    <div v-else class="row no-gutters text-center">
     <div class="col-12 col-md-12 col-lg-4" v-if="!this.antecipacaoGambiarra">
        <label>Retorno Líquido Anual</label>
        <span class="info bold">{{formatCurrency(retornoBrutoAnual)}}% a.a.</span>
      </div>
      <div class="col-12 col-md-12 col-lg-6" v-if="this.antecipacaoGambiarra">
        <label>Retorno Final do Período</label>
        <span class="info bold">{{this.taxaGambiarra}}%</span>
      </div>
      <div class="col-12 col-md-12 col-lg-6" v-else>
        <label>Retorno Líquido Mensal</label>
        <span class="info bold">{{formatCurrency(retornoBrutoMensal)}}% a.m.</span>
      </div>
      <div class="col-12 col-md-12 col-lg-6" v-if="this.antecipacaoGambiarra">
        <label>Retorno Esperado período</label>
        <span class="info bold">{{formatInt(this.CDIGambiarra||0)}}% CDI</span>
      </div>
      <div class="col-12 col-md-12 col-lg-6" v-else>
        <label>Retorno Estimado Anual</label>
        <span class="info bold">{{formatInt(cdi||0)}}% CDI</span>
      </div>
      <div class="col-12">
        <p class="small " v-if="!this.antecipacaoGambiarra">
          * A taxa de juros acima já é líquida de Imposto de Renda
        </p>
      </div>
    </div>

    <hr class="divider">

    <div class="row no-gutters text-center">
      <div class="col-12 col-md-12 col-lg-6">
        <label>Rating</label>
        <span class="info bold">{{score}}</span>
      </div>
      <div class="col-12 col-md-12 col-lg-6">
        <label>Duração esperada</label>
        <span class="info bold" v-if="this.loanRequest.PrazoDias > 1">{{this.loanRequest.PrazoDias}} Dias</span>
        <span class="info bold" v-else>{{prazo}} Meses</span>
      </div>
    </div>

    <hr class="divider">

    <div class="row no-gutters text-center">
      <div class="col-12">
        <h5>Finaliza em {{daysToFinish}} dias*</h5>
      </div>
      <div class="col-12">
        <div class="clearfix itens">
          <span class="float-left">Levantado: {{formatCurrency(reachedValuePercentage)}}%</span>
          <span class="float-right">Faltam: <strong>R$ {{missingValue}}</strong></span>
        </div>
        <div class="progress">
          <div class="progress-bar" role="progressbar" :style="`width: ${reachedValuePercentageINT}%;`" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
            <span class="progress-value">{{formatCurrency(reachedValuePercentage)}}%</span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <span class="info__invest"><strong>{{countInvestmentReservations}}</strong> investidores</span>
      </div>
    </div>

    <hr class="divider">

    <investment-reservation-data
      ref="investData"
      :loan-request="loanRequest"
      :investmentConfirmed="this.investmentConfirmed"
      @submit="(data) => $emit('submit', data)"
    />

  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/styles/iouu/mixins";

@include sm {
  .company-view {
    aside {
      span {
        &.info {
          display: inline-block;
          padding-top: 12px;
          padding-bottom: 15px;
        }
      }
    }
  }
}

 @include xs {
   .company-view {
      aside {

        h5 {
          font-size: calcRem(14);
          line-height: calcRem(26);
          background-size: calcRem(25);
          padding-left: calcRem(30);
          
        }

        span {
          &.value {
            font-size: calcRem(25);
          }

          &.info {
            font-size: calcRem(18);
            font-weight: calcRem(30);
            display: inline-block;
            padding-top: 12px;
             padding-bottom: 15px;

            &__invest {
              font-size: calcRem(14);
            }
          }
        }

        .dates {
          &{
            text-align: center;
          }

          img {
            display: none;
          }

          label {
            font-size: calcRem(12);
            line-height: calcRem(8);
          }

          span {
            &.date {
              font-size: calcRem(14);
              padding-bottom: 1rem;
            }
          }
        }

        .itens {
          span {
            font-size: calcRem(12);
            width: 100%;
            text-align: center;
          }
        }
      }
    }
 }

</style>


<script>
  import InvestmentReservationData from '@/components/CompanyProfile/InvestmentReservationData'

  export default {
    components: { InvestmentReservationData },
    props: {
      loanRequest: { required: true },
      investmentConfirmed: { required: true, type: Boolean },
    },
    data() {
      return {
        antecipacaoGambiarra: false,
        taxaGambiarra: 5.26,
				CDIGambiarra: 641.46
      }
    },
    computed: {

      fimCaptacao() {
        return this.loanRequest.FimCaptacao.toLocaleDateString('pt-BR')
      },

      valorSolicitacao() {
          return this.formatCurrency(this.loanRequest.Valor)
      },

      taxaInternaRetorno() {
        return this.loanRequest.TaxaInternaRetorno
      },

      taxaTotalEfetiva() {
        return this.loanRequest.TaxaTotalEfetiva
      },

      retornoBrutoAnual() {
        return this.loanRequest.RetornoBrutoAnual;
      },

      retornoBrutoMensal() {
        return this.loanRequest.RetornoBrutoMensal
      },

      cdi() {
        return this.loanRequest.Cdi
      },

      score() {
        return this.loanRequest.Score
      },
      
      prazo() {
        return this.loanRequest.Prazo
      },
      
      inicioCaptacao() { return this.loanRequest.InicioCaptacao.toLocaleDateString('pt-BR'); },

      daysToFinish() {
        const miliSecs = (this.loanRequest.FimCaptacao.getTime()+86400000) - new Date().getTime()
        if(miliSecs > 0) {
          return Number.parseInt(miliSecs/1000/60/60/24)
        } else
        {
          return 0
        }
      }, 
      
      reachedValuePercentageINT() { 
        var val = this.loanRequest.ValorCaptado*100 / this.loanRequest.Valor;
        val = val < 100 ? val : 100;

        return Number.parseInt(val);
      },
      reachedValuePercentage() { 
        var val = this.loanRequest.ValorCaptado * 100 / this.loanRequest.Valor;
        val = val < 100.00 ? val : 100.00;
        
        return this.formatCurrency(val); 
      },
      missingValue() {
        var val = this.loanRequest.Valor - this.loanRequest.ValorCaptado;
        val = val > 0 ? val : 0;

        return this.formatCurrency(val); 
      },
      countInvestmentReservations() { return this.loanRequest.QuantidadeReservasInvestimento }
    },
    methods: {
      formatCurrency(value) {
        return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
      },
       formatInt(value) {
        return value.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 0})
      },
      Cancelar()
      {
        this.$refs.investData.Cancelado();
      },
      verificaProduto(produto) {
					
					if(produto != "EMPRES") {
						return true
					}

					return false
			},
    },
    created() {
      if(this.loanRequest._id === "5e9de72f796877415093cb1d" || this.loanRequest._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CompanyProfile/InvestmentReservationForm.vue